import { render, staticRenderFns } from "./SideBarTabOptions.vue?vue&type=template&id=1bca0c42&"
import script from "./SideBarTabOptions.vue?vue&type=script&lang=js&"
export * from "./SideBarTabOptions.vue?vue&type=script&lang=js&"
import style0 from "./SideBarTabOptions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports